var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateJobTabIconLeadSource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2994 2.31143L14.9702 4.38559C16.316 4.97934 16.316 5.96101 14.9702 6.55476L10.2994 8.62893C9.76896 8.86643 8.89812 8.86643 8.36771 8.62893L3.69688 6.55476C2.35104 5.96101 2.35104 4.97934 3.69688 4.38559L8.36771 2.31143C8.89812 2.07393 9.76896 2.07393 10.2994 2.31143Z",
    stroke: "#253D87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 8.7085C2.375 9.3735 2.87375 10.1414 3.48333 10.4106L8.85875 12.8014C9.27042 12.9835 9.7375 12.9835 10.1413 12.8014L15.5167 10.4106C16.1263 10.1414 16.625 9.3735 16.625 8.7085",
    stroke: "#253D87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 12.6665C2.375 13.4028 2.81042 14.0678 3.48333 14.3686L8.85875 16.7594C9.27042 16.9415 9.7375 16.9415 10.1413 16.7594L15.5167 14.3686C16.1896 14.0678 16.625 13.4028 16.625 12.6665",
    stroke: "#253D87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateJobTabIconLeadSource);
export default __webpack_public_path__ + "static/media/create_job_tab_icon_lead_source.fb93dc5cd9e7c693177a5748eda9861e.svg";
export { ForwardRef as ReactComponent };